// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"834":"c7ccebdbf37126f83384","926":"90c63f89bf5aaf79313b"}[chunkId] + ".chunk.js";
};